<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 18:11:11
 * @LastEditors: mdb
-->
<template>
  <TagsManage subdomain="lbu" :permission="permission" />
</template>

<script setup lang="ts">
import TagsManage from '@/views/marketing/marketingManage/tagsManage/index.vue'

const permission = {
  add: 'lbu_tags_add_btn',
  edit: 'lbu_tags_edit_btn',
  del: 'lbu_tags_del_btn',
  enable: 'lbu_tags_enable_btn',
  disable: 'lbu_tags_disable_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuTagManage' }
</script>

<style scoped></style>
